import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VrpApp from './App.vue';
import VrpRouter from './router.js';
import VueGtag from 'vue-gtag'; // vue-gtag 가져오기
import * as Sentry from '@sentry/vue';

const app = createApp(VrpApp);

// 로컬 개발 환경에서는 Sentry 초기화 하지 않음
if (process.env.NODE_ENV !== 'development') {
	let dsnValue = '';

	if (process.env.VUE_APP_BUILD_MODE === 'MAIN') {
		dsnValue =
			'https://d812cb0ac0d2d8454ec2a053a23f2bc3@sentry.atlantruck.com/9';
	} else if (process.env.VUE_APP_BUILD_MODE === 'DEV') {
		dsnValue =
			'https://fb17716591e94cda603d8bf3cd3bab25@sentry.atlantruck.com/7';
	}

	Sentry.init({
		app,
		dsn: dsnValue,
		integrations: [
			Sentry.browserTracingIntegration({ VrpRouter }),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 1.0,
		tracePropagationTargets: [],
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	});
}

// Google Analytics 설정 추가
// Main 환경에서만 구글 애널리스틱 동작하도록 수정
if (process.env.VUE_APP_BUILD_MODE === 'MAIN') {
	app.use(VueGtag, {
		config: { id: 'G-8F3BEEDDR6' }, // 프로덕션 측정 ID
	});
}

app.use(VrpRouter);
app.use(createPinia());

if (app) {
	window.app = app.mount('#app');
	window.$gtag = app.config.globalProperties.$gtag;
}
